import React from 'react'
import MpinUpdate from '../../containers/MyProfile/MpinUpdate'

const Change_mpin = () => {
  return (
    <div><MpinUpdate/></div>
  )
}

export default Change_mpin